<template>
  <div class="row">
    <div class="col">
      <div class="row" style="margin-bottom: 10px">
        <div class="col-9">
          <a-tooltip title="Legenda dos Tipos de Documentos." placement="right">
            <button @click="mostrarLegendaTipoDocumento(true)" type="button" class="btn btn-secondary"><i class="fa-solid fa-circle-info"></i></button>
          </a-tooltip>
        </div>
      </div>
      <div class="row">
        <div class="col-9">
          <label for="situacao">Lista de Tipos de Documentos</label>
          <select class="form-select" id="situacao" v-model="docSelect">
            <option v-for="(doc, optionIndex) in documentos" :key="optionIndex" :value="doc">
              {{ doc.nomeDocumento }}
            </option>
          </select>
        </div>

        <div class="col">
          <div class="col-3">
            <div style="margin-top: 23px; margin-bottom: 10px">
              <button type="button" class="btn btn-primary" @click="selecionarDoc" style="margin-right: 10px">Selecionar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col"></div>
    <div class="row" style="margin-top: 10px">
      <div class="col">
        <ckeditor v-model="editorData" :editor="editor"></ckeditor>
        <div class="col">
          <div style="margin-top: 23px; margin-bottom: 10px">
            <button type="button" class="btn btn-primary float-end" @click="salvarDocumento" style="margin-right: 10px">Salvar</button>
          </div>
        </div>
      </div>
      <div class="col">
        <a-table :dataSource="documentosGerados" :columns="columns">
          <template #data="{ record }">
            <span>{{ formatDate(record.dataInsercao) }}</span>
          </template>

          <template #action="{ record }">
            <a-tooltip title="Editar Documento" placement="top">
              <i class="fa-solid fa-pen-to-square upload-archive" style="margin-left: 4%; cursor: pointer" @click="editarDoc(record)"></i>
            </a-tooltip>

            <a-tooltip title="Visualizar Documento" placement="top">
              <i class="far fa-file-alt upload-archive" style="margin-left: 4%; cursor: pointer" disabled @click="visualizarDocumento(record)"></i>
            </a-tooltip>

            <a-tooltip title="Excluir Documento" placement="bottomRight">
              <a-popconfirm title="Confirma exclusão ?" @confirm="deletarDocumento(record)">
                <i class="fa-solid fa-trash upload-archive" style="margin-left: 3%; cursor: pointer"></i>
              </a-popconfirm>
            </a-tooltip>
          </template>
        </a-table>
      </div>
    </div>
  </div>
  <a-modal v-model:visible="showLegendaTipoDocumentoDialog" title="Legenda dos Tipos de Documentos" width="1000px" height="600px">
    <ul class="nav nav-tabs nav-justified mb-3" id="ex10" role="tablist">
      <li class="nav-item" role="presentation">
        <a class="nav-link active" id="ex3-tab-10" data-bs-toggle="tab" href="#ex3-tabs-10" role="tab" aria-controls="ex3-tabs-1" aria-selected="true">Atestado Psicológico</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="ex3-tab-20" data-bs-toggle="tab" href="#ex3-tabs-20" role="tab" aria-controls="ex3-tabs-2" aria-selected="false">Declaração</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="ex3-tab-30" data-bs-toggle="tab" href="#ex3-tabs-30" role="tab" aria-controls="ex3-tabs-30" aria-selected="false">Laudo</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="ex3-tab-50" data-bs-toggle="tab" href="#ex3-tabs-50" role="tab" aria-controls="ex3-tabs-30" aria-selected="false">Parecer Psicológico</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="ex3-tab-40" data-bs-toggle="tab" href="#ex3-tabs-40" role="tab" aria-controls="ex3-tabs-30" aria-selected="false">Relatório Psicológico</a>
      </li>
    </ul>
    <div class="tab-content" id="ex2-content">
      <div class="tab-pane fade show active" id="ex3-tabs-10" role="tabpanel" aria-labelledby="ex3-tab-10">
        <LegendaTipoDocumentoAtestadoPsicologico />
      </div>
      <div class="tab-pane fade" id="ex3-tabs-20" role="tabpanel" aria-labelledby="ex3-tab-20">
        <LegendaTipoDocumentoDeclaracao />
      </div>
      <div class="tab-pane fade" id="ex3-tabs-30" role="tabpanel" aria-labelledby="ex3-tab-30">
        <LegendaTipoDocumentoLaudo />
      </div>
      <div class="tab-pane fade" id="ex3-tabs-50" role="tabpanel" aria-labelledby="ex3-tab-50">
        <LegendaTipoDocumentoParecerPsicologico />
      </div>
      <div class="tab-pane fade" id="ex3-tabs-40" role="tabpanel" aria-labelledby="ex3-tab-40">
        <LegendaTipoRelatorioPsicologico />
      </div>
    </div>

    <template #footer>
      <button style="margin-top: 20px" type="button" class="btn btn-primary" @click="mostrarLegendaTipoDocumento(false)">Fechar</button>
    </template>
  </a-modal>
</template>

<script>
import { GerarDocumento } from '@/components/models/gerarDocumento';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { gerarHtmlDocumentoRegistroAtendimento, gerarHtmlDocumentoPaciente } from '@/components/service/templateDocumentoService';
import { createGerarDocumento, deletarDocumento, getGerarDocByIdRegistroAtendimento, visualizarDocumentoPorId, getGerarDocByIdPaciente } from '@/components/service/gerar-documento';
import { formatarData } from '@/utils/servicos-utils';
import { openNotification, typesNotification } from '@/utils/notifications';
import LegendaTipoDocumentoAtestadoPsicologico from '@/components/pages/pages-atendimento/LegendaTipoDocumentoAtestadoPsicologico';
import LegendaTipoDocumentoDeclaracao from '@/components/pages/pages-atendimento/LegendaTipoDocumentoDeclaracao';
import LegendaTipoDocumentoLaudo from '@/components/pages/pages-atendimento/LegendaTipoDocumentoLaudo';
import LegendaTipoRelatorioPsicologico from '@/components/pages/pages-atendimento/LegendaTipoDocumentoRelatorioPsicologico';
import LegendaTipoDocumentoParecerPsicologico from '@/components/pages/pages-atendimento/LegendaTipoDocumentoParecerPsicologico';

export default {
  name: 'GerarDocumento',
  components: {
    LegendaTipoDocumentoAtestadoPsicologico,
    LegendaTipoDocumentoDeclaracao,
    LegendaTipoDocumentoLaudo,
    LegendaTipoRelatorioPsicologico,
    LegendaTipoDocumentoParecerPsicologico,
  },
  props: {
    paciente: {
      type: Object,
      required: false,
    },
    registroAtendimento: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      documentos: [],
      documentosGerados: [],
      editorData: '<p>Conteúdo inicial</p>',
      editor: ClassicEditor,
      docSelect: null,
      showLegendaTipoDocumentoDialog: false,
      objDocumento: {
        id: null,
        content: null,
        tipoDocumento: null,
        registroAtendimento: this.registroAtendimento,
        paciente: this.paciente,
      },
      columns: [
        {
          title: 'Tipo Documento',
          dataIndex: 'tipoDocumento',
          key: 'tipoDocumento',
          slots: { customRender: 'tipoDocumento' },
        },
        {
          title: 'Data',
          dataIndex: 'data',
          key: 'data',
          slots: { customRender: 'data' },
        },
        {
          title: 'Ação',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    this.documentos = GerarDocumento();
    await this.getDocumentos();
  },
  methods: {
    async selecionarDoc() {
      if (this.registroAtendimento && this.registroAtendimento.id) {
        await gerarHtmlDocumentoRegistroAtendimento({
          objeto: this.registroAtendimento,
          nomeDocumentoHtml: this.docSelect.documento,
          listaDadosDocumento: [],
        }).then((r) => {
          this.objDocumento.id = null;
          this.editorData = r.data;
        });
      } else {
        await gerarHtmlDocumentoPaciente({
          objeto: this.paciente,
          nomeDocumentoHtml: this.docSelect.documento,
          listaDadosDocumento: [],
        }).then((r) => {
          this.objDocumento.id = null;
          this.editorData = r.data;
        });
      }
    },
    async getDocumentos() {
      console.log(this.paciente);
      if (this.registroAtendimento && this.registroAtendimento.id) {
        await getGerarDocByIdRegistroAtendimento(this.registroAtendimento.id).then((r) => {
          this.documentosGerados = r.data;
        });
      } else {
        await getGerarDocByIdPaciente(this.paciente.id).then((r) => {
          this.documentosGerados = r.data;
        });
      }
    },
    formatDate(data) {
      return formatarData(new Date(data), 'DD/MM/YYYY HH:mm');
    },
    async salvarDocumento() {
      this.objDocumento.content = this.editorData;
      if (this.objDocumento.id === null) {
        this.objDocumento.tipoDocumento = this.docSelect.nomeDocumento;
      }
      await createGerarDocumento(this.objDocumento).then(async () => {
        this.objDocumento.id = null;
        this.objDocumento.tipoDocumento = null;
        this.objDocumento.content = null;
        this.editorData = '<p></p>';

        await this.getDocumentos();

        openNotification(typesNotification.success, 'Documento salvo com sucesso.');
      });
    },
    editarDoc(record) {
      this.objDocumento = record;
      this.editorData = record.content;
    },
    async visualizarDocumento(record) {
      await visualizarDocumentoPorId(record.id).then((r) => {
        const blob = new Blob([r.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url);
      });
    },
    async deletarDocumento(record) {
      await deletarDocumento(record.id).then(async () => {
        openNotification(typesNotification.success, 'Documento deletado com sucesso.');
        await this.getDocumentos();
      });
    },
    async mostrarLegendaTipoDocumento(valor) {
      this.showLegendaTipoDocumentoDialog = valor;
    },
  },
};
</script>

<style scoped>
.upload-archive {
  font-size: 25px;
}
</style>
